'use client';

import { type FC, useEffect } from 'react';
import { useDataDog } from './use-data-dog-rum';
import { useTrackVirtPathAndPageMeta } from './use-track-virt-path-and-page-meta';

type TrackingProps = {
  dataDogViewName: string;

  state: any; // todo
  virtPathViewName: string;
};

export const Tracking: FC<TrackingProps> = ({ dataDogViewName, state, virtPathViewName }) => {
  const trackVirtPathAndPageMeta = useTrackVirtPathAndPageMeta();

  useDataDog({
    checkout: 'EaaS',
    state,
    viewName: dataDogViewName,
  });

  useEffect(() => {
    trackVirtPathAndPageMeta(
      `/checkout-b2c-energieloesungen-${virtPathViewName.replace(' ', '-').toLocaleLowerCase()}/`,
      `Checkout B2C Energielösungen ${virtPathViewName}`,
      'Other',
    );
  }, [trackVirtPathAndPageMeta, virtPathViewName]);

  return null;
};
